import { resolveComponent, createBlock, openBlock, withCtx, createVNode, normalizeProps, guardReactiveProps, createTextVNode, toDisplayString } from "vue";
/* empty css                         */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
import { VIcon } from "vuetify/components/VIcon";
import { VListItem, VListItemTitle } from "vuetify/components/VList";
import { VMenu } from "vuetify/components/VMenu";
const _sfc_main = {
  name: "RangeDateFilterItem",
  props: {
    modelValue: null,
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "lets-icons:calendar-duotone"
    },
    showDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    },
    valueStr() {
      if (!this.value) {
        return null;
      }
      const values = [];
      const dates = Array.isArray(this.value) ? this.value : [this.value];
      for (const date of dates) {
        values.push(this.$moment(date).format("ll"));
      }
      return values.join(" - ");
    }
  }
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");
  const _component_b_date_edit = resolveComponent("b-date-edit");
  return openBlock(), createBlock(VMenu, {
    modelValue: $data.menu,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.menu = $event),
    offset: "8",
    "close-on-content-click": false,
    location: "end"
  }, {
    activator: withCtx(({ props }) => [
      createVNode(VListItem, normalizeProps(guardReactiveProps(props)), {
        prepend: withCtx(() => [
          createVNode(_component_b_icon, {
            size: "20",
            class: "mr-2",
            icon: $props.icon
          }, null, 8, ["icon"])
        ]),
        append: withCtx(() => [
          createVNode(VIcon, null, {
            default: withCtx(() => _cache[3] || (_cache[3] = [
              createTextVNode("mdi-chevron-right")
            ])),
            _: 1,
            __: [3]
          })
        ]),
        default: withCtx(() => [
          createVNode(VListItemTitle, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString($props.label) + " " + toDisplayString($props.showDate && $options.valueStr ? `(${$options.valueStr})` : ""), 1)
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: withCtx(() => [
      createVNode(_component_b_date_edit, {
        modelValue: $options.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event) => $options.value = $event),
          _cache[1] || (_cache[1] = ($event) => $data.menu = false)
        ],
        range: true,
        inline: true
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
const RangeDateFilterItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  RangeDateFilterItem as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
